module.exports = __webpack_public_path__ + "static/media/typography_1920x1080.3bb3d0f5.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/assets/typography_1920x1080.jpg
 ** module id = 163
 ** module chunks = 0
 **/